<template>
  <component :is="currentComponent"></component>
</template>
<script>
import theApi from '@/mixins/theApi';
import store from '@/store/store';
//import router from "@/router/router";

export default {
  computed: {
    experience() {
      if (this.loginType == 'student') {
        const experiences = store.getters['authStudent/experiences'];
        const experience = experiences.find((i) => i.id == this.$route.params.id);
        return experience;
      } else {
        return store.getters['authTeacher/experience'];
      }
    },
    activity() {
      if (this.experience) {
        const activity = this.experience.activities.find((a) => a.slug == this.$route.params.slug);
        return activity;
      }
      return false;
    },
    activityTitle() {
      const activityIndex = this.experience.activities.findIndex(
        (a) => a.slug == this.$route.params.slug,
      );
      return (
        this.experience.vje.name + ' Activity ' + (activityIndex + 1) + ': ' + this.activity.title
      );
    },
    componentInstance() {
      return () =>
        import(
          '@/views/WorkExperiences/' +
            this.experience.vje.folder_name +
            '/activities/' +
            this.$route.params.slug +
            '.vue'
        );
    },
    isEditable() {
      if (this.experience && this.experience.active) return true;
      return false;
    },
    currentComponent: function () {
      if (this.componentToDisplay) {
        return () =>
          import(
            '@/views/WorkExperiences/' +
              this.experience.vje.folder_name +
              '/activities/' +
              this.componentToDisplay +
              '.vue'
          );
      }
      return null;
    },
  },
  data() {
    return {
      apiUrl:
        localStorage.getItem('login_type') === 'student'
          ? $vjeConfig.VUE_APP_API_URL + 'student/experiences/activities/get'
          : $vjeConfig.VUE_APP_API_URL + 'teacher/experiences/activities/get',
      data: {},
      uploaded_file: '',
      uploaded_files: null,
      loginType: localStorage.getItem('login_type'),
      componentToDisplay: null,
      disableSave: false,
      showSaveProgress: false,
      isModified: false,
      intervalid1: null,
    };
  },
  methods: {
    async saveActivity(activity_id, data, file, filetype) {
      const formData = new FormData();
      formData.append('student_vje_id', this.$route.params.id);
      formData.append('activity_id', activity_id);
      formData.append('data', JSON.stringify(data));
      if (typeof file !== 'undefined') formData.append('file', file);
      else formData.append('file', -1);
      if (typeof filetype !== 'undefined') formData.append('filetype', filetype);

      formData.append('completed', 1);

      this.disableSave = true;
      this.showSaveProgress = true;
      theApi.methods
        .makeCall(
          false,
          'experiences/activities/save',
          'post',
          formData,
          'Activity saved successfully!',
          true,
        )
        .then(
          (data) => {
            if (data.status == 'OK') {
              this.isModified = false;

              //Update Vuex activity
              const activity_data = {
                student_vje_id: this.$route.params.id,
                activity_id: this.activity.id,
                data: data.activity,
              };
              store.commit('authStudent/updateExperienceActivity', activity_data);
              if (typeof data.file !== 'undefined') {
                this.uploaded_file = data.file;
              }
              //If all activities are completed & experience not active anymore, redirect
              if (typeof data.vje_is_active !== 'undefined' && !data.vje_is_active) {
                //store.commit('authStudent/setActiveExperienceID', null);
                const experience_data = {
                  id: this.$route.params.id,
                  data: {
                    activities_completed: 1,
                  },
                };
                store.commit('authStudent/modifyExperience', experience_data);
                //router.push('/student/work-experience-completed');
              }
            }
            this.disableSave = false;
            this.showSaveProgress = false;
          },
          () => {
            this.disableSave = false;
            this.showSaveProgress = false;
          },
        );
    },
    async autosaveActivity() {
      let activity_id = this.$route.params.slug;
      let data = this.data;

      const formData = new FormData();
      formData.append('student_vje_id', this.$route.params.id);
      formData.append('activity_id', activity_id);
      formData.append('data', JSON.stringify(data));

      formData.append('completed', 0);

      this.disableSave = true;
      this.showSaveProgress = true;
      theApi.methods
        .makeCall(
          false,
          'experiences/activities/save',
          'post',
          formData,
          'Activity autosaved successfully!',
          true,
        )
        .then(
          (data) => {
            if (data.status == 'OK') {
              //Update Vuex activity
              const activity_data = {
                student_vje_id: this.$route.params.id,
                activity_id: this.activity.id,
                data: data.activity,
              };
              store.commit('authStudent/updateExperienceActivity', activity_data);
              this.isModified = false;
            }
            this.disableSave = false;
            this.showSaveProgress = false;
          },
          () => {
            this.disableSave = false;
            this.showSaveProgress = false;
          },
        );
    },
    async saveActivityMultipleFiles(activity_id, data, files, filetype) {
      const formData = new FormData();
      formData.append('student_vje_id', this.$route.params.id);
      formData.append('activity_id', activity_id);
      formData.append('data', JSON.stringify(data));
      for (const [key, value] of Object.entries(files)) {
        formData.append(key, value);
      }
      formData.append('numFiles', Object.keys(files).length);
      if (typeof filetype !== 'undefined') formData.append('filetype', filetype);

      formData.append('completed', 1);

      this.disableSave = true;
      theApi.methods
        .makeCall(
          false,
          'experiences/activities/save',
          'post',
          formData,
          'Activity saved successfully!',
          true,
        )
        .then(
          (data) => {
            if (data.status == 'OK') {
              //Update Vuex activity
              const activity_data = {
                student_vje_id: this.$route.params.id,
                activity_id: this.activity.id,
                data: data.activity,
              };
              store.commit('authStudent/updateExperienceActivity', activity_data);
              if (typeof data.file !== 'undefined') {
                this.uploaded_file = data.file;
              }
              if (typeof data.multiple_files !== 'undefined') {
                for (let i = 1; i <= Object.keys(data.multiple_files).length; i++) {
                  if (typeof data.multiple_files[i] !== 'undefined') {
                    this.uploaded_files[i] = data.multiple_files[i];
                  }
                }
                this.uploaded_file = data.file;
              }
              //If all activities are completed & experience not active anymore, redirect
              if (typeof data.vje_is_active !== 'undefined' && !data.vje_is_active) {
                const experience_data = {
                  id: this.$route.params.id,
                  data: {
                    activities_completed: 1,
                  },
                };
                store.commit('authStudent/modifyExperience', experience_data);
                //router.push('/student/work-experience-completed');
              }
            }
            this.disableSave = false;
          },
          () => {
            this.disableSave = false;
          },
        );
    },
    enableAutosave: function () {
      const self = this;

      this.intervalid1 = setInterval(function () {
        if (self.isModified) {
          self.autosaveActivity();
        }
      }, 60000);
    },
    getActivityData() {
      const student_activity = this.experience.student_activities.find(
        (a) => a.activity_id == this.activity.id,
      );
      if (student_activity) {
        const data = JSON.parse(student_activity.data);
        if (data.data) {
          this.data = data.data;
          this.isModified = false;
        } else {
          this.data = {};
        }
        this.uploaded_file = data.file;
        if (typeof data.multiple_files !== 'undefined') {
          this.uploaded_files = data.multiple_files;
        }
      } else {
        this.data = {};
        this.uploaded_file = '';
      }
    },
    getData() {
      return this.data;
    },
    setData(data) {
      this.data = data;
    },
    getUploadedFile() {
      return this.uploaded_file;
    },
    setUploadedFile(data) {
      this.uploaded_file = data;
    },
    getUploadedFiles() {
      return this.uploaded_files;
    },
    setUploadedFiles(data) {
      this.uploaded_files = data;
    },
    startFileUpload() {
      this.disableSave = true;
    },
    endFileUpload() {
      this.disableSave = false;
      this.isModified = true;
    },
    appendUploadedFileToData(index, url) {
      this.data['uploaded_file_' + index] = url;
    },
    showIframePopup(url, elemId) {
      store.dispatch('popup/showIframePopup', url);
      if (elemId) store.commit('popup/setFocusElemOnPopupClose', elemId);
    },
    showVideoPopup(url, elemId) {
      if (url.includes('youtube.com')) store.dispatch('popup/showIframePopup', url);
      else store.dispatch('popup/showVideoPopup', url);
      if (elemId) store.commit('popup/setFocusElemOnPopupClose', elemId);
    },
  },
  mounted() {
    this.componentToDisplay = this.$route.params.slug;
    this.getActivityData();
    this.$emit('activityLoaded', this.activity.title);

    let vm = this;
    setTimeout(function () {
      vm.isModified = false;
      vm.enableAutosave();
    }, 500);
  },
  destroyed() {
    clearInterval(this.intervalid1);
    this.intervalid1 = null;
  },
  watch: {
    '$route.params.slug'() {
      this.componentToDisplay = this.$route.params.slug;
      this.getActivityData();
      this.isModified = false;
    },
    data: {
      handler: function () {
        this.isModified = true;
      },
      deep: true,
    },
  },
  reactiveProvide: {
    name: 'saveConfig',
    include: ['disableSave', 'showSaveProgress'],
  },
  provide: function () {
    return {
      saveActivity: this.saveActivity,
      saveActivityMultipleFiles: this.saveActivityMultipleFiles,
      getActivityData: this.getActivityData,
      getData: this.getData,
      setData: this.setData,
      getUploadedFile: this.getUploadedFile,
      setUploadedFile: this.setUploadedFile,
      getUploadedFiles: this.getUploadedFiles,
      setUploadedFiles: this.setUploadedFiles,
      uploaded_file: this.uploaded_file,
      isEditable: this.isEditable,
      activityTitle: this.activityTitle,
      //isFileUploading: this.isFileUploading,
      startFileUpload: this.startFileUpload,
      endFileUpload: this.endFileUpload,
      appendUploadedFileToData: this.appendUploadedFileToData,
      showIframePopup: this.showIframePopup,
      showVideoPopup: this.showVideoPopup,
      closePopup: this.closePopup,
      isModified: this.isModified,
    };
  },
};
</script>
